(function ($) {
  window.DGS.OnLoad.getInstance().register(function () {
    $('.component.content').each(function () {
      if (!$(".field-content p", $(this)).length) {
        $(".field-content", $(this)).wrapInner("<p></p>");
      }
    });
  });
})(jQuery);